import { IDataWithLocalizedName } from '../../contracts/localized-data.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LocalizedNameComponent extends Component implements IDataWithLocalizedName {
  static readonly TYPE_ID: string = '8cea7287910d49568230426f91732d2d';

  constructor(
    public readonly names: LocalizedString,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return LocalizedNameComponent.TYPE_ID;
  }

  static empty(): LocalizedNameComponent {
    return new LocalizedNameComponent(LocalizedString.empty());
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedNameComponent {
    return new LocalizedNameComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'names')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'names': context.toData(this.names),
    };
  }

  clone(): this {
    return new LocalizedNameComponent(
        this.names.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.names, this.names);
  }
}

export class LocalizedNameComponentBuilder extends DataModelBuilder<LocalizedNameComponent> {
  build(context: SerializationContext, map: SerializedData): LocalizedNameComponent {
    return LocalizedNameComponent.fromMap(context, map);
  }
}
